<template>
  <update-card
    :tabs="tabs"
    :id="id"
    storeNamespace="services"
    objectNamespace="O_pricelist"
    @visitedTabs="visitedTabs"
  >

  </update-card>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import UpdateCard from '@/components/card/UpdateCard'
import PricelisPricePeriod from '@/modules/Service/components/Pricepackage/PricelistPricePeriod.vue'
export default {
    components: {
        UpdateCard
    },
    props: {
        id: {
            type: String
        },
    },
    data() {
        return {
            tabsVisited: []
        }
    },
    computed: {
        tabs() {
            return [
                {
                    name: 'Grunduppgifter', 
                    icon: 'mdi-tray-full',
                    props: {
                        id: this.id,
                        initialLoad: this.tabsVisited.includes(0) ? true : false
                    }
                },
                {
                    name: 'Prisperioder', 
                    icon: 'mdi-tray-full',
                    component: PricelisPricePeriod
                }
            ]
        }
    },
    methods: {
        visitedTabs(value) {
            this.tabsVisited = value
        }
    },
}
</script>

<style>

</style>